import React, { useEffect, useState } from "react";
import { TICKETING_API } from "../api";
import { useMutation, useQuery } from "@tanstack/react-query";
import { setBackIcon, setPageTitle } from "../slice";
import { BsInbox, BsQuestionCircle, BsWrench } from "react-icons/bs";
import TicketItems from "../components/ticketing/TicketItems";
import { Box, Typography, Divider, Button, Grid, InputBase } from "@mui/material";
import { useDispatch } from "react-redux";
import InfiniteScroll from "../components/InfiniteScroll";
import { FiMessageSquare } from "react-icons/fi";
import TicketingCard from "../components/ticketing/TicketingCard";
import { AiOutlineUser } from "react-icons/ai";
import { HiOutlineOfficeBuilding } from "react-icons/hi";

function Ticketing() {
  const PAGE_SIZE = process.env.REACT_APP_PAGE_SIZE;
  const dispatch = useDispatch();
  const [tickets, setTickets] = useState([]);
  const [categories, setCategoties] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const handleSearch = () => {
    if (page === 0) {
      getTickets();
    } else {
      setPage(0);
    }
  };

  const { refetch: getTickets, isLoading } = useQuery(
    ["getAllTickets", page],
    () => TICKETING_API.GetMyQuestionsGrid(search, "", page * PAGE_SIZE, PAGE_SIZE),
    {
      onSuccess: ({ data }) => {
        let temp = [...(page === 0 ? [] : tickets), ...data.data.data];
        setHasMore(temp.length < data.data.totalCount);
        setTickets(temp);
      },
    }
  );

  useQuery(["getAllCategories"], () => TICKETING_API.GetAllCategories(), {
    onError: () => {
      //todo : inja bayad error handle shavad
    },
    onSuccess: ({ data }) => {
      if (data.success) setCategoties(data.data);
    },
  });
  useEffect(() => {
    dispatch(setPageTitle("پیگیری‌ها و پاسخگویی"));
    dispatch(setBackIcon({ hasBackIcon: false, route: "" }));
  }, [dispatch]);

  return (
    <InfiniteScroll
      hasMore={hasMore}
      loadMore={() => setPage((prev) => prev + 1)}
      scrollTarget="scrollable_div"
      isLoading={isLoading}
      dataLength={tickets.length}
    >
      <Box display="flex" flexDirection="column" width={"100%"} alignItems="end">
        <Box display="flex" justifyContent="center" width="100%" mt={7}>
          <TicketingCard
            icon={<HiOutlineOfficeBuilding color="#4C466F" fontSize="40px" />}
            label={categories.find(({ id }) => id === 4)?.name}
            id={4}
          />
          <TicketingCard
            icon={<AiOutlineUser color="#4C466F" fontSize="40px" />}
            label={categories.find(({ id }) => id === 3)?.name}
            id={3}
          />
          <TicketingCard
            icon={<FiMessageSquare color="#4C466F" fontSize="40px" />}
            label={categories.find(({ id }) => id === 2)?.name}
            id={2}
          />
        </Box>
        <Box display="flex" justifyContent="center" width="100%" my={4}>
          <TicketingCard
            icon={<BsWrench color="#4C466F" fontSize="40px" />}
            label={categories.find(({ id }) => id === 7)?.name}
            id={7}
          />
          <TicketingCard
            icon={<BsQuestionCircle color="#4C466F" fontSize="40px" />}
            label={categories.find(({ id }) => id === 6)?.name}
            id={6}
          />
          <TicketingCard
            icon={<BsInbox color="#4C466F" fontSize="40px" />}
            label={categories.find(({ id }) => id === 5)?.name}
            id={5}
          />
        </Box>
        <Box my={3} width="100%">
          <Divider />
        </Box>
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row-reverse" }}
          justifyContent="flex-start"
          alignItems="center"
          width="100%"
          my={2}
        >
          <Typography
            variant="h1"
            textAlign="right"
            marginLeft="1rem"
            marginBottom={{ xs: "2rem", sm: 0 }}
          >
            لیست تیکت ها
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width={{ xs: "100%", sm: "60%", md: "40%" }}
            bgcolor="#FAFAFA"
            p={1}
            borderRadius={4}
          >
            <Button variant="s1" onClick={handleSearch}>
              جستجو کن
            </Button>
            <InputBase
              sx={{
                direction: "rtl",
                border: "none !important",
                flex: 1,
                fontSize: "0.9rem",
                boxSizing: "border-box",
                paddingRight: "0.5rem",
                "input::placeholder": {
                  color: "#4C466F",
                },
              }}
              placeholder="جستجو کنید..."
              name="SearchInCenters"
              onChange={(event) => setSearch(event.target.value)}
            />
          </Box>
        </Box>
        <Grid container display={{ xs: "none", sm: "flex", md: "flex" }} my={2} px={2}>
          <Grid item xs={2.8}>
            <Typography variant="h2" color="#AAAAAA" textAlign="right">
              تاریخ آخرین اقدام
            </Typography>
          </Grid>
          <Grid item xs={1.45}>
            <Typography variant="h2" color="#AAAAAA" textAlign="right">
              تاریخ ثبت
            </Typography>
          </Grid>
          <Grid item xs={1.75}>
            <Typography variant="h2" color="#AAAAAA" textAlign="right">
              دسته بندی
            </Typography>
          </Grid>
          <Grid item xs={1.5}>
            <Typography variant="h2" color="#AAAAAA" textAlign="right">
              وضعیت
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="h2" color="#AAAAAA" textAlign="right">
              عنوان تیکت
            </Typography>
          </Grid>
          <Grid item xs={1.5}>
            <Typography variant="h2" color="#AAAAAA" textAlign="right">
              شماره تیکت
            </Typography>
          </Grid>
        </Grid>
        {tickets.map(({ number, categoryName, title, createDate, lastActionDate, state, id }) => {
          return (
            <TicketItems
              key={id}
              number={number}
              categoryName={categoryName}
              title={title}
              createDate={createDate}
              lastActionDate={lastActionDate}
              state={state}
              id={id}
            />
          );
        })}
      </Box>
    </InfiniteScroll>
  );
}

export default Ticketing;
